function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.3181 0H5.79567C4.22781 0.0421296 2.73966 0.710597 1.6546 1.86015C0.56953 3.00971 -0.0247845 4.54746 0.000792636 6.13929V83.8607C-0.0247845 85.4525 0.56953 86.9903 1.6546 88.1398C2.73966 89.2894 4.22781 89.9579 5.79567 90H70.2043C71.7722 89.9579 73.2603 89.2894 74.3454 88.1398C75.4305 86.9903 76.0248 85.4525 75.9992 83.8607V25.4571L50.3181 0ZM49.3681 8.00357L68.3677 26.9679H49.3681V8.00357ZM6.33399 83.5714V6.42857H44.3332V32.1429H69.666V83.5714H6.33399Z",
  fill: "white",
  fillOpacity: 0.5
});
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 90,
    viewBox: "0 0 76 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.7e7f062ba4740aee41f4011e546e60e0.svg";
export { ForwardRef as ReactComponent };